import { IsDocumentDefined } from '../is-document/is-document';

export const AddCssClassToBody = (css: string): boolean => {
  if (IsDocumentDefined() && css) {
    const sheet = document?.createElement('style');
    sheet.innerHTML = css;
    sheet.id = 'cvna-parser-css';
    document?.head?.appendChild(sheet);
  }

  return true;
};
